/*
 * TRUECELL PDP — gedeelde animatielogica voor de tc-secties.
 * Aangeroepen door tc-zweettest.liquid (SWEAT) en tc-8uur.liquid (BARS).
 *
 * Levering: <script src="{{ 'tc-pdp.js' | asset_url }}" defer></script> per sectie.
 * Idempotent: één globale init onder window.__tcPdp, roots worden per stuk
 * geobserveerd (WeakSet), en scan() draait opnieuw bij shopify:section:load.
 * Meerdere identieke <script src>-tags zijn veilig door de init-guard.
 */
(function () {
  'use strict';

  var NS = (window.__tcPdp = window.__tcPdp || {});

  // Reduced-motion één keer bepalen.
  if (typeof NS._reduced === 'undefined') {
    NS._reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // Roots die al geobserveerd zijn (voorkomt dubbel observeren).
  if (!NS._observed) NS._observed = new WeakSet();
  // Timers per root, zodat replay netjes reset zonder andere roots te raken.
  if (!NS._timers) NS._timers = new WeakMap();

  function clearTimers(root) {
    var arr = NS._timers.get(root);
    if (arr) { for (var i = 0; i < arr.length; i++) clearTimeout(arr[i]); }
    NS._timers.set(root, []);
  }
  function after(root, ms, fn) {
    var arr = NS._timers.get(root) || [];
    arr.push(setTimeout(fn, ms));
    NS._timers.set(root, arr);
  }

  // Leest een data-attribuut met een nette fallback.
  function attr(root, name, fallback) {
    if (!root) return fallback;
    var v = root.getAttribute(name);
    return (v !== null && v !== '') ? v : fallback;
  }

  // ── SWEAT-effect (replica van runSweat uit het design) ──────────────
  function runSweat(root) {
    if (!root) return;
    clearTimers(root);

    var q = function (sel) { return root.querySelector(sel); };
    var drop   = q('[data-el="droplet"]');
    var cStain = q('[data-el="cotton-stain"]');
    var cHoles = q('[data-el="cotton-holes"]');
    var cLabel = q('[data-el="cotton-label"]');
    var tStain = q('[data-el="tc-stain"]');
    var tLabel = q('[data-el="tc-label"]');

    // Bewerkbare fasetekst (uit data-attributen op de root) met NL-fallbacks.
    var idle = attr(root, 'data-idle',     'Klaar voor de test');
    var c1   = attr(root, 'data-cotton-1', 'Zweet blijft aan het oppervlak');
    var c2   = attr(root, 'data-cotton-2', 'Blijft nat → gaat ruiken');
    var c3   = attr(root, 'data-cotton-3', 'En uiteindelijk: gaten');
    var t1   = attr(root, 'data-tc-1',     'Vocht trekt de vezel in');
    var t2   = attr(root, 'data-tc-2',     'Droog → blijft fris ✓');

    var set   = function (el, prop, val) { if (el) el.style[prop] = val; };
    var label = function (el, text)      { if (el) el.textContent = text; };
    // Houdt de centrering intact terwijl alleen de schaal wijzigt.
    var tf = function (scale) { return 'translate(-50%,-50%) scale(' + scale + ')'; };

    // Reset naar beginstaat.
    if (cStain) { cStain.style.opacity = '0'; cStain.style.transform = tf('.3'); }
    if (cHoles) cHoles.style.opacity = '0';
    if (tStain) { tStain.style.opacity = '0'; tStain.style.transform = tf('.3'); }
    label(cLabel, idle);
    label(tLabel, idle);
    if (drop) { drop.style.animation = 'none'; void drop.offsetWidth; } // forceer reflow

    if (NS._reduced) {
      // Direct naar de eindstaat springen.
      set(cStain, 'opacity', '1'); if (cStain) cStain.style.transform = tf('1.15');
      set(cHoles, 'opacity', '1'); label(cLabel, c3);
      set(tStain, 'opacity', '0'); label(tLabel, t2);
      return;
    }

    // Druppel valt (0.7s), daarna de getimede sequentie.
    if (drop) drop.style.animation = 'tcFall .7s ease-in forwards';

    after(root, 650, function () {
      set(cStain, 'opacity', '1'); if (cStain) cStain.style.transform = tf('1');
      set(tStain, 'opacity', '.9'); if (tStain) tStain.style.transform = tf('1');
      label(cLabel, c1); label(tLabel, t1);
    });
    after(root, 1700, function () {
      if (cStain) cStain.style.transform = tf('1.25'); label(cLabel, c2);
      set(tStain, 'opacity', '0'); if (tStain) tStain.style.transform = tf('.3'); label(tLabel, t2);
    });
    after(root, 2900, function () {
      set(cHoles, 'opacity', '1'); label(cLabel, c3);
    });
  }

  // ── BARS-effect (replica van runBars uit het design) ────────────────
  function runBars(root) {
    if (!root) return;
    var bars = root.querySelectorAll('[data-bar]');
    if (!bars.length) return;

    if (NS._reduced) {
      for (var j = 0; j < bars.length; j++) {
        bars[j].style.height = (bars[j].getAttribute('data-target') || '0') + '%';
      }
      return;
    }
    // Gestaffeld met 120ms per balk.
    var i = 0;
    bars.forEach(function (b) {
      after(root, 120 * (i++), function () {
        b.style.height = (b.getAttribute('data-target') || '0') + '%';
      });
    });
  }

  // ── IntersectionObserver (drempel 0.35), één gedeelde instantie ──────
  function getObserver() {
    if (NS._io) return NS._io;
    NS._io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        if (el.hasAttribute('data-tc-sweat')) runSweat(el);
        if (el.hasAttribute('data-tc-bars'))  runBars(el);
        NS._io.unobserve(el);
      });
    }, { threshold: 0.35 });
    return NS._io;
  }

  // ── Scan: observeer nieuwe roots + koppel replay-knoppen ─────────────
  function scan() {
    var io;
    try { io = getObserver(); } catch (e) { io = null; }

    var roots = document.querySelectorAll('[data-tc-sweat],[data-tc-bars]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (NS._observed.has(root)) continue;
      NS._observed.add(root);
      if (io) {
        io.observe(root);
      } else {
        // Geen IO-ondersteuning: meteen afspelen.
        if (root.hasAttribute('data-tc-sweat')) runSweat(root);
        if (root.hasAttribute('data-tc-bars'))  runBars(root);
      }
    }

    // Replay-knoppen binnen een sweat-root.
    var btns = document.querySelectorAll('[data-tc-sweat] [data-tc-replay]');
    for (var b = 0; b < btns.length; b++) {
      var btn = btns[b];
      if (btn.__tcBound) continue;
      btn.__tcBound = true;
      btn.addEventListener('click', function () {
        var host = this.closest ? this.closest('[data-tc-sweat]') : null;
        if (host) runSweat(host);
      });
    }
  }
  NS.scan = scan;

  // ── Init één keer; scan bij load-events én direct als DOM klaar is ───
  if (!NS._init) {
    NS._init = true;
    document.addEventListener('DOMContentLoaded', scan);
    // Thema-editor: sectie (her)geladen.
    document.addEventListener('shopify:section:load', function () { scan(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
